module.exports = __webpack_public_path__ + "img/logo-08.2ca3c643.svg";